import { DocumentStoreActions, DocumentStoreMutations } from "@/constants/store/document/documentStoreConstants";
import { SiteDocument } from "@/dataModel";

export default {
  [DocumentStoreActions.SET_SELECTED_DOCUMENT]({ commit }: { commit: Function }, document: SiteDocument[]): void {
    commit(DocumentStoreMutations.SET_SELECTED_DOCUMENT, document);
  },
};
